import { Link } from 'react-router-dom'

export function BlogBreadcrumbs({ path }: { path: string }) {
  const parts = path.split('/').filter(Boolean)
  return (
    <nav className="blog-breadcrumbs" aria-label="Breadcrumb">
      <ol>
        {parts.map((part, index) => (
          <li
            key={index}
            aria-current={index === parts.length - 1 ? 'page' : undefined}
          >
            {index === parts.length - 1 ? (
              index === 0 ? (
                'Blog'
              ) : (
                part
              )
            ) : (
              <Link to={`/${parts.slice(0, index + 1).join('/')}`}>
                {index === 0 ? 'Blog' : part}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}
